// Five Peaks Construction — shared content/constants
export const LOGO = {
  // Navy on transparent — best for light backgrounds
  primary:
    "https://customer-assets.emergentagent.com/job_five-peaks-build/artifacts/44f8anq3_Copy%20of%20Five%20Peaks%20Mathematic.png",
  // Yellow background full lockup — alternative
  alt: "https://customer-assets.emergentagent.com/job_five-peaks-build/artifacts/2ufema1i_S3%20%281%29.png",
  // Mark / icon-only (with skyscraper bg)
  mark: "https://customer-assets.emergentagent.com/job_five-peaks-build/artifacts/km0w6le4_S2%20%281%29.png",
};

export const COMPANY = {
  name: "Five Peaks Construction",
  legal: "Five Peaks Construction LLC",
  phone: "801-347-2220",
  phoneHref: "tel:+18013472220",
  email: "FivepeakconstructionUT@gmail.com",
  emailHref: "mailto:FivepeakconstructionUT@gmail.com",
  facebook: "https://www.facebook.com/fivepeaksconstructionllc/",
  instagram: "https://www.instagram.com/fivepeaks_llc",
  location: "Utah",
  tagline: "Built to last. Crafted to live in.",
};

export const SERVICES = [
  { key: "painting", name: "Painting", blurb: "Interior & exterior. Spray, roll, custom finishes.", icon: "PaintBucket" },
  { key: "framing", name: "Framing", blurb: "Wood & metal stud framing for residential and commercial.", icon: "Hammer" },
  { key: "drywall", name: "Drywall", blurb: "Hang, tape, mud, texture and patch. Level-5 finish available.", icon: "Square" },
  { key: "flooring", name: "Flooring", blurb: "Hardwood, LVP, tile, carpet and underlayment.", icon: "Layers" },
  { key: "frp", name: "FRP Panels", blurb: "Fiberglass Reinforced Panels for kitchens, healthcare, and retail.", icon: "PanelTop" },
  { key: "finish-carpentry", name: "Finish Carpentry", blurb: "Doors, windows, closets, trim and millwork.", icon: "DoorOpen" },
  { key: "new-construction", name: "New Construction", blurb: "Ground-up residential and commercial builds.", icon: "Building2" },
  { key: "remodeling", name: "Remodeling", blurb: "Kitchens, baths, additions, full home transformations.", icon: "Wrench" },
  { key: "maintenance", name: "Maintenance Dept.", blurb: "Ongoing facility, property and tenant improvement services.", icon: "HardHat" },
];

export const PORTFOLIO = [
  {
    title: "Commercial Tenant Build-Out",
    category: "Commercial · Demolition & Framing",
    url: "https://customer-assets.emergentagent.com/job_five-peaks-build/artifacts/m1p2qa4g_IMG_20230318_110710376.jpg",
  },
  {
    title: "Custom Kitchen Remodel",
    category: "Residential · Remodeling & Finish",
    url: "https://customer-assets.emergentagent.com/job_five-peaks-build/artifacts/hn061rfp_IMG_20230112_172331538.jpg",
  },
  {
    title: "Steel Stud Framing",
    category: "Commercial · Framing",
    url: "https://customer-assets.emergentagent.com/job_five-peaks-build/artifacts/dkq1trs6_IMG_20230302_114554872.jpg",
  },
  {
    title: "Open-Concept Kitchen Island",
    category: "Residential · Finish Carpentry",
    url: "https://customer-assets.emergentagent.com/job_five-peaks-build/artifacts/zygpa9bt_IMG_20230112_172311112.jpg",
  },
  {
    title: "Commercial Framing in Progress",
    category: "Commercial · New Construction",
    url: "https://customer-assets.emergentagent.com/job_five-peaks-build/artifacts/9rgv9gvw_IMG_20230121_112757370.jpg",
  },
];

export const HERO_BG =
  "https://images.unsplash.com/photo-1556156653-e5a7c69cc263?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob3VzZSUyMGNvbnN0cnVjdGlvbiUyMGZyYW1pbmd8ZW58MHx8fHwxNzgxODk3MTM3fDA&ixlib=rb-4.1.0&q=85";

export const ABOUT_BG =
  "https://images.unsplash.com/photo-1509316785289-025f5b846b35?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHx1dGFoJTIwbW91bnRhaW5zJTIwbGFuZHNjYXBlfGVufDB8fHx8MTc4MTg5NzEzN3ww&ixlib=rb-4.1.0&q=85";

export const STATS = [
  { value: "200+", label: "Projects Delivered" },
  { value: "15yr", label: "Combined Crew Experience" },
  { value: "9", label: "Specialty Trades In-House" },
  { value: "100%", label: "Licensed & Insured" },
];

export const TESTIMONIALS = [
  {
    quote:
      "Five Peaks remodeled our kitchen and primary bath on schedule. The finish carpentry is the cleanest work we've seen in Utah.",
    name: "Marcus & Lena R.",
    role: "Homeowner · Lehi, UT",
  },
  {
    quote:
      "We hired them for a 12,000 sq ft tenant improvement — framing, drywall, FRP, and paint. Crew showed up every day and stayed in scope.",
    name: "Jordan P.",
    role: "Facilities Director · SLC",
  },
  {
    quote:
      "Their maintenance team handles three of our retail locations. Responsive, tidy, and they communicate clearly.",
    name: "Cody V.",
    role: "Property Manager",
  },
];
